/**
 * Segment analytics hosts, shared by the runtime analytics client
 * (`src/services/analytics.ts`) and the loyalty CSP allowlist
 * (`src/modules/loyalty/security/loyaltyCsp.ts`). Keeping both the origin the
 * browser is pointed at and the origin the CSP allows in one place means they
 * can never drift apart.
 */

/**
 * Default Segment CDN origin — where `@segment/analytics-next` loads its bundle
 * and fetches project settings. Overridable at build time via
 * `VITE_SEGMENT_API_BASE_URL`; this is the fallback when that var is unset.
 */
export const DEFAULT_SEGMENT_CDN_ORIGIN = 'https://cdn.segment.com';

/**
 * Segment's fixed event-ingestion host (`api.segment.io`, hardcoded in
 * `@segment/analytics-next`); the SDK POSTs events here after init. Not
 * env-overridable, so it is pinned rather than derived from config.
 */
export const SEGMENT_EVENT_API_ORIGIN = 'https://api.segment.io';
